export default __webpack_public_path__ + "static/media/fintech-dk.7f320666.svg";